<app-tree
  [tree]="tree"
  [showCount]="false"
  (selectNode)="selectNode($event)"
  (deselectNode)="deselectNode($event)"
  [selectedNodes]="selectedNodes"></app-tree>
<div class="form-check border-top mt-3 pt-3">
  <label class="form-check-label small text-gray-700">
    <input
      type="checkbox"
      class="form-check-input"
      [checked]="eosl"
      (click)="toggleEosl()"
      i18n>
    Show EOL product versions
  </label>
</div>
